import * as React from 'react';
import styled, {css} from 'styled-components'
import {ConstBreakPoint, ConstColor} from "../../../../config/styles_const/styles_const";
import AvatarSmall from "../../atom/avatar/avatar_small";
import Paragraph from "../../atom/text/paragraph";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
    isOwnMessage: boolean;
    messageSignatureIconURL: string;
    messageSignatureName: string;
    messageCreateTimeString: string;
    messageText: string;
    messageFileUrl?: string;
    handleClickFile: (event: React.MouseEvent<HTMLElement>) => void;
}

const MessageCard: React.FC<IProps> = (props) => {

    const { isOwnMessage, messageSignatureIconURL, messageSignatureName, messageCreateTimeString, messageText, messageFileUrl, handleClickFile } = props;

    return (
        <MessageWrapper isOwnMessage={isOwnMessage}>
            <MessageCardWrapper isOwnMessage={isOwnMessage}>
                <Area area={"avatar"}><AvatarSmall src={messageSignatureIconURL}/></Area>
                <Area area={"name"}><Name bold={true}>{messageSignatureName}</Name></Area>
                <Area area={"datetime"}><DateTime>{messageCreateTimeString}</DateTime></Area>
                <Area area={"text"}> <MessageText>{messageText}</MessageText></Area>
                <Area area={"file"}>
                    {messageFileUrl &&
                    <a
                        href={messageFileUrl}
                        onClick={handleClickFile}
                        target={`_blank`}
                    >
                        <MessageFile icon={"'\f0c6'"} >添付ファイル</MessageFile>
                    </a>
                    }
                </Area>
            </MessageCardWrapper>
        </MessageWrapper>

    )

};

export default MessageCard;

const template = `
    "avatar ...  name ...  datetime "
    "...    ...  ...  ...  ...      "
    "text   text text text text     "
    "file   file file file file     "
`;

const templateSp = `
    "datetime datetime  datetime  "
    "...      ...       ...  "
    "avatar   ...       name "
    "...      ...       ...  "
    "text     text      text "
    "file     file      file "
`;

const MessageWrapper = styled.div<Pick<IProps, 'isOwnMessage'>>`
    ${props => props.isOwnMessage ? css`
        margin-left: auto;
    ` : `
        margin-right: auto;
    `}

    width: fit-content;
`

const MessageCardWrapper = styled.div<Pick<IProps, 'isOwnMessage'>>`
    ${props => props.isOwnMessage ? css`
        background: ${ConstColor.LightGray};
        margin-left: 25px;
        @media screen and (min-width: ${ConstBreakPoint.Default}) {
            margin-left: 40px;
        }
    ` : `
        background: ${ConstColor.White};
        border: 1px solid ${ConstColor.PlaceholderAndBorder};
        margin-right: 25px;
        @media screen and (min-width: ${ConstBreakPoint.Default}) {
            margin-right: 40px;
        }
    `}
    
    width: fit-content;
    border-radius: 5px;
    display: grid;
    grid-template-areas: ${templateSp};
    grid-template-columns: auto 10px 1fr;
    grid-template-rows: auto 10px auto 15px auto auto;
    justify-content: center;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        grid-template-areas: ${template};
        grid-template-columns: auto 10px auto 1fr auto;
        grid-template-rows: auto 15px auto auto;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    
    padding: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
`;

const Area = styled.div<{area: string}>`
    grid-area: ${(props) => props.area};
    display: grid;
    align-items: center;
`;

const Name = styled(ParagraphSup)`
    margin-right: 20px;
`;

const DateTime = styled(ParagraphSup)`
    color: ${ConstColor.Gray};
`;

const MessageText = styled(Paragraph)`
    white-space:pre-wrap;
`;

const MessageFile = styled(ParagraphSup)`
    margin-top: 20px;
    color: ${ConstColor.Corporate}
`;


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/card/message_card.tsx